module.exports = __webpack_public_path__ + "img/50.d85a27d8.jpg";